import {
  ENDPOINT_ADMIN_BRANCH_CREATE,
  ENDPOINT_ADMIN_BRANCH_DELETE, ENDPOINT_ADMIN_BRANCH_LIST,
  ENDPOINT_ADMIN_BRANCH_UPDATE
} from "../../constants/api";

const {
  apiRequestAdmin,
} = require('../ws');


export function apiAdminMposUsersList(params) {
  return apiRequestAdmin(ENDPOINT_ADMIN_BRANCH_LIST, params);
}
export function apiAdminMposUsersCreate(params) {
  return apiRequestAdmin(ENDPOINT_ADMIN_BRANCH_CREATE, params);
}
export function apiAdminMposUsersUpdate(params) {
  return apiRequestAdmin(ENDPOINT_ADMIN_BRANCH_UPDATE, params);
}
export function apiAdminMposUsersDelete(params) {
  return apiRequestAdmin(ENDPOINT_ADMIN_BRANCH_DELETE, params);
}
